import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { capitalize } from "../Utils/commonFiles";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { CreatifyUser } from "../Assets/Images";
import { logout } from "../Redux/auth/AuthSlice";
import { getUserFromSession } from "../helpers/api/apiCore";

const TopHeader = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const user = getUserFromSession();

  const getPageTitle = () => {
    if (pathname.includes("/dashboard")) return "Dashboard";
    if (pathname.includes("/custom/image")) return "Custom Image";
    if (pathname.includes("/custom/video")) return "Custom Video";
    if (pathname.includes("/gallery")) return "Gallery";
    if (pathname.includes("/influencers")) return "Influencers";
    if (pathname.includes("/instagram")) return "Instagram";
    return "Dashboard";
  };

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const handleLogout = async () => {
    dispatch(logout());
  };

  return (
    <div>
      <Container fluid>
        <div className="dashboard-items mt-3">
          <div className="right-top-bar">
            <div className="left-side-bar">
              <button
                className="mobile-toggle-btn d-xl-none"
                onClick={toggleSidebar}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 12H21M3 6H21M3 18H21"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <h2>{getPageTitle()}</h2>
            </div>
            <div className="right-side-bar">
              <div className="notify-icon">
                <div className="notification-icon">
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C16.3402 6.10655 17.8786 8.41425 18 11V14C18.1526 15.2608 18.8949 16.3742 20 17H4C5.10511 16.3742 5.84739 15.2608 6 14V11C6.12137 8.41425 7.65983 6.10655 10 5"
                      stroke="#2F2B3D"
                      stroke-opacity="0.9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 17V18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18V17"
                      stroke="#2F2B3D"
                      stroke-opacity="0.9"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                </div>
              </div>
              <div className="user-img-top">
                {user?.image ? (
                  <img src={user.image} alt="User" />
                ) : (
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: "#3457d5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    {user?.name?.charAt(0)?.toUpperCase() || "C"}
                  </div>
                )}
                {/* <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {user?.image ? (
                      <img src={user.image} alt="User" />
                    ) : (
                      <div style={{
                      marginTop:"5px",
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#3457d5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 'bold'
                      }}>
                        {user?.name?.charAt(0)?.toUpperCase() || 'C'}
                      </div>
                    )}
                  </Dropdown.Toggle> 

                  <Dropdown.Menu>
                    <Dropdown.Item className="">
                      <div className="drop-pro-view">
                        {user?.image ? (
                          <img src={user.image} alt="User" />
                        ) : (
                          <div style={{
                          marginTop:"5px",
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#3457d5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: 'bold'
                          }}>
                            {user?.name?.charAt(0)?.toUpperCase() || 'C'}
                          </div>
                        )}
                        <div className="admin-name">
                          <h3>{user?.name || 'Creatify User'}</h3>
                          <p>{user?.email || 'user@creatify.com'}</p>
                        </div>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <div className="my-profile">
                      <Dropdown.Item href="my-profile">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <ellipse
                            cx="10.9999"
                            cy="6.41667"
                            rx="3.66667"
                            ry="3.66667"
                            stroke="#2F2B3D"
                            stroke-opacity="0.9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.5 19.25V17.4167C5.5 15.3916 7.14162 13.75 9.16667 13.75H12.8333C14.8584 13.75 16.5 15.3916 16.5 17.4167V19.25"
                            stroke="#2F2B3D"
                            stroke-opacity="0.9"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        My Profile
                      </Dropdown.Item>
                    </div>

                    <div>
                      <Dropdown.Item
                        onClick={handleShow1}
                        className="logout-btn"
                      >
                        Logout
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="14"
                          viewBox="0 0 15 14"
                          fill="none"
                        >
                          <path
                            d="M3.41659 12.8333C3.26188 12.8333 3.1135 12.7718 3.00411 12.6624C2.89471 12.553 2.83325 12.4047 2.83325 12.25V1.74996C2.83325 1.59525 2.89471 1.44688 3.00411 1.33748C3.1135 1.22808 3.26188 1.16663 3.41659 1.16663H11.5833C11.738 1.16663 11.8863 1.22808 11.9957 1.33748C12.1051 1.44688 12.1666 1.59525 12.1666 1.74996V3.49996H10.9999V2.33329H3.99992V11.6666H10.9999V10.5H12.1666V12.25C12.1666 12.4047 12.1051 12.553 11.9957 12.6624C11.8863 12.7718 11.738 12.8333 11.5833 12.8333H3.41659ZM10.9999 9.33329V7.58329H6.91659V6.41663H10.9999V4.66663L13.9166 6.99996L10.9999 9.33329Z"
                            fill="white"
                          />
                        </svg>
                      </Dropdown.Item>
                    </div>
                  </Dropdown.Menu>
                </Dropdown> */}
              </div>
            </div>
          </div>
        </div>
        <Modal show={show1} onHide={handleClose1} centered>
          <Modal.Body>
            <div className="profile-modals-cmn">
              <h2>Log Out</h2>
              <p>Are you sure you want to log out your account?</p>
            </div>
            <div className="cmn-modal-action">
              <button onClick={handleClose1}>Close</button>
              <button
                onClick={() => handleLogout()}
                style={{
                  background:
                    "linear-gradient(0deg, rgba(52, 87, 213, 0.8) 0%, #3457d5 100%)",
                }}
                className="border-0"
              >
                Log Out
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
};

export default TopHeader;
